interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface LoadingState {
  isDeleteButtonLoading: boolean
  isAuditSubmitButtonLoading: boolean
}
interface State {
  dataSource: any[]
  isTableLoading: boolean
  paginationOption: PaginationOption
  searchParam: any
  selectedRows: any[]
  selectedRowKeys: any[]
  loadingState: LoadingState
  oldState: any
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPaginationOptionAction'
  | 'setOrderCountsState'
  | 'setDataSourceAction'
  | 'setIsTableLoading'
  | 'setSearchParamAction'
  | 'setSelectedRowsAction'
  | 'setSelectedRowKeysAction'
  | 'setOldStateAction'
  | 'reloadStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,

  paginationOption: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  selectedRowKeys: [],
  loadingState: {
    isDeleteButtonLoading: false,
    isAuditSubmitButtonLoading: false,
  },
  oldState: {},
}

export const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'reloadStateAction':
      return action.payload
    default:
      throw new Error('no match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParamAction = (val: any): Action => ({
  type: 'setSearchParamAction',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (val: PaginationOption): Action => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): Action => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): Action => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setSelectedRowKeysAction = (val: string[]): Action => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})
interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface LoadingState {
  isDeleteButtonLoading: boolean
  isAuditSubmitButtonLoading: boolean
}
interface State {
  dataSource: any[]
  isTableLoading: boolean
  paginationOption: PaginationOption
  searchParam: any
  selectedRows: any[]
  selectedRowKeys: any[]
  loadingState: LoadingState
  oldState: any
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPaginationOptionAction'
  | 'setOrderCountsState'
  | 'setDataSourceAction'
  | 'setIsTableLoading'
  | 'setSearchParamAction'
  | 'setSelectedRowsAction'
  | 'setSelectedRowKeysAction'
  | 'setOldStateAction'
  | 'reloadStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,

  paginationOption: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  selectedRowKeys: [],
  loadingState: {
    isDeleteButtonLoading: false,
    isAuditSubmitButtonLoading: false,
  },
  oldState: {},
}

export const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'reloadStateAction':
      return action.payload
    default:
      throw new Error('no match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParamAction = (val: any): Action => ({
  type: 'setSearchParamAction',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (val: PaginationOption): Action => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): Action => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): Action => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setSelectedRowKeysAction = (val: string[]): Action => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})
